import { render, staticRenderFns } from "./PostPreviewAttachments.vue?vue&type=template&id=7cd6d2d4&scoped=true"
import script from "./PostPreviewAttachments.vue?vue&type=script&lang=js"
export * from "./PostPreviewAttachments.vue?vue&type=script&lang=js"
import style0 from "./PostPreviewAttachments.vue?vue&type=style&index=0&id=7cd6d2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd6d2d4",
  null
  
)

export default component.exports